<div class="col-12 d-flex">
  <label class="mb-0 title"> {{card.cardInformation?.cardLimit | currency: '₺'}} Faturana Yansıt Limitinden aktarmak
    istediğiniz
    tutarı girin</label>
</div>
<div class="col-12 d-flex justify-content-center">
  <input class="input-style" placeholder="₺0.00" [(ngModel)]="price">
</div>
<div class="col-12 d-flex justify-content-center">
  <a class="all-transfer" (click)="allTransferClick()">Tümünü Aktar</a>
</div>
<div class="col-12 d-flex info-div">
  <img class="info" [src]="'assets/images/info.png'" [srcset]="'assets/images/info@2x.png 2x, assets/images/info@3x.png 3x'" alt="logo"/>
  <label class="info-description">Belirlediğiniz tutar karşılığında sanal para alınacaktır.</label>
</div>
<div class="col-12  d-flex button-div">
  <button class="button-style" (click)="continue()"><span class="text-style">Devam Et</span></button>
</div>
